import { render } from "./NewClaimYearSelector.vue?vue&type=template&id=ce067b32&scoped=true&ts=true"
import script from "./NewClaimYearSelector.vue?vue&type=script&lang=ts"
export * from "./NewClaimYearSelector.vue?vue&type=script&lang=ts"

import "./NewClaimYearSelector.vue?vue&type=style&index=0&id=ce067b32&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.29_vue@3.5.27_typescript@5.9.3__webpack@5.105.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce067b32"]])

export default __exports__